import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import toast from 'react-hot-toast'
import { getLocalApiUrl } from '../config/api'
import AuthShell, { AuthField, AuthSubmitButton } from '../components/AuthShell'

export default function ForgotPassword() {
  const [identifier, setIdentifier] = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [message, setMessage] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      const res = await fetch(getLocalApiUrl('/api/auth/forgot-password'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username_or_email: identifier.trim() }),
      })
      const j = await res.json()
      if (!res.ok || !j.success) {
        throw new Error(j.error || 'Request failed')
      }
      setMessage(j.message || 'If an account exists, we have sent password setup instructions.')
      setSent(true)
    } catch (err) {
      toast.error(err.message || 'Something went wrong. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthShell title="Forgot password" subtitle="We will email you a link to set a new password.">
      {sent ? (
        <div className="space-y-4">
          <div className="rounded-md bg-green-50 border border-green-200 px-4 py-3 text-sm text-green-800">
            {message}
          </div>
          <p className="text-sm text-gray-600">
            Check your inbox and spam folder. The link expires in 2 days.
          </p>
          <Link
            to="/login"
            className="block text-center text-sm font-medium"
            style={{ color: '#0A5169' }}
          >
            Return to sign in
          </Link>
        </div>
      ) : (
        <form className="space-y-6" onSubmit={handleSubmit}>
          <AuthField
            label="Username or email"
            id="identifier"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            placeholder="Enter your username or email"
            autoComplete="username"
          />
          <AuthSubmitButton loading={loading}>Send reset link</AuthSubmitButton>
        </form>
      )}
    </AuthShell>
  )
}
